// Just export an array of image URLs
import ChurchOutdoor from "../../Assets/Images/SlideShowImages/church-outdoor.jpeg"
import ChurchBook from "../../Assets/Images/SlideShowImages/ChurchBook.jpeg"
import ChurchDoor from "../../Assets/Images/SlideShowImages/church-door.jpeg"
import ChurchDoor1 from "../../Assets/Images/SlideShowImages/churchDoor_1.jpeg"
import AlterVeil from "../../Assets/Images/SlideShowImages/alterVeil.jpeg"
import Archangel from "../../Assets/Images/SlideShowImages/ArchangelMicheal.jpeg"
import Candles from "../../Assets/Images/SlideShowImages/Candles.jpeg"
import Censer from "../../Assets/Images/SlideShowImages/censer.jpeg"
import ChurchIndoor from "../../Assets/Images/SlideShowImages/church-indoor.jpeg"
import ChurchIndoor1 from "../../Assets/Images/SlideShowImages/Church-Inside.jpeg"
import Daff from "../../Assets/Images/SlideShowImages/Daff.jpeg"
import EucharistBox from "../../Assets/Images/SlideShowImages/eucharistBox.jpeg"
import Iconostasis from "../../Assets/Images/SlideShowImages/iconostasis.jpeg"
import Iconostasis1 from "../../Assets/Images/SlideShowImages/iconostasis_1.jpeg"
import Iconostasis2 from "../../Assets/Images/SlideShowImages/Iconostasis (2).jpeg"
import Icons from "../../Assets/Images/SlideShowImages/Icons.jpeg"
import Mangalya from "../../Assets/Images/SlideShowImages/Mangalya.jpeg"
import OstrichEgg from "../../Assets/Images/SlideShowImages/ostrichEgg.jpeg"
import StGeorge from "../../Assets/Images/SlideShowImages/st.george.jpeg"
import StVerina from "../../Assets/Images/SlideShowImages/st.Verina.jpeg"
import StMary from "../../Assets/Images/SlideShowImages/st.Mary.jpeg"



const images: string[] = [
    Archangel,
    ChurchOutdoor,
    ChurchDoor,
    ChurchIndoor1,
    AlterVeil,
    Iconostasis2,
    Iconostasis1,
    Iconostasis,
    Daff,
    Candles,
    Censer,
    EucharistBox,
    Mangalya,
    ChurchBook,
    OstrichEgg,
    Icons,
    StMary,
    StGeorge,
    StVerina,
];

export default images;
